import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { AuthUser } from 'app/core/auth/core/auth-user.model';
import { AuthState } from 'app/core/auth/core/auth.state';
import { combineLatest, Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { MaintenanceService } from '../maintenance/maintenance.service';
import { MenuItems } from './menu-items';

@Directive({
    selector: '[odqMenuItem]',
    standalone: false
})
export class MenuItemDirective implements OnDestroy {

  @Select(AuthState.signedIn) signedIn$: Observable<boolean>;
  @Select(AuthState.user) user$: Observable<AuthUser>;
  maintenanceInfo$: Observable<any>;

  private destroy$ = new Subject<void>();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private menuItems: MenuItems,
    private maintenanceService: MaintenanceService
  ) { 
    this.maintenanceInfo$ = this.maintenanceService.getMaintenanceState();
  }

  @Input('odqMenuItem')
  public set route(route: string) {
    combineLatest([this.signedIn$, this.user$, this.maintenanceInfo$]).pipe(
      takeUntil(this.destroy$),
      tap(data => {
        this.viewContainer.clear();
        const [signedIn, user, maintenanceState] = data;
        if ((this.menuItems.hasRoles(route, user) || !signedIn ) && !!maintenanceState && !maintenanceState[route]) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
